import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"position":"relative","display":"inline-block","margin":"10px 10px 0 10px","align-self":"flex-end"} }

import {computed} from "vue";

interface Props {
  value?: string | number
  badgeStyle?: string
  badgeType?: string
  overlap?: string | boolean // only notification or dot
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogBadge',
  props: {
    value: { default: undefined },
    badgeStyle: { default: undefined },
    badgeType: { default: undefined },
    overlap: { type: [String, Boolean], default: undefined }
  },
  setup(__props: any) {


const props = __props


const _class = computed(() => {
  let t_c = "e-badge"
  switch (props.badgeStyle) {
    case "primary" :
      t_c += " e-badge-primary";
      break;
    case "secondary" :
      t_c += " e-badge-secondary";
      break;
    case "success" :
      t_c += " e-badge-success";
      break;
    case "danger" :
      t_c += " e-badge-danger";
      break;
    case "warning" :
      t_c += " e-badge-warning";
      break;
    case "info" :
      t_c += " e-badge-info";
      break;
    case "light" :
      t_c += " e-badge-light";
      break;
    case "dark" :
      t_c += " e-badge-dark";
      break;
  }
  switch (props.badgeType) {
    case "circle":
      t_c += " e-badge-circle";
      break;
    case "pill":
      t_c += " e-badge-pill";
      break;
    case "notification":
      t_c += " e-badge-notification";
      break;
    case "dot":
      t_c += " e-badge-dot";
      break;
  }
  if (props.overlap) {
    t_c += " e-badge-overlap";
  }

  /*
    const instance = getCurrentInstance();
    console.log("parent:");
    console.log(instance?.parent?.style);
    instance.parent.style = "position:relative;display:inline-block;margin:20px 20px 10px 20px;"
    console.log(instance?.parent?.style);
  */
  return t_c
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("span", {
      class: _normalizeClass(_class.value)
    }, _toDisplayString(__props.value), 3)
  ]))
}
}

})